export default __webpack_public_path__ + "static/media/K2700Gallery6.7f566a26.jpg";